import { useState } from 'react';
import { Image as ImageIcon, Video } from 'lucide-react';
import { cn } from '../../components/ui/utils';

interface MediaThumbProps {
  url: string | null | undefined;
  mediaType?: string;
  /** Классы контейнера — задают размер, напр. 'size-10' или 'w-14 h-14' */
  className?: string;
  iconClassName?: string;
}

/**
 * Превью публикации. Ссылки на CDN Instagram подписаны и протухают через
 * недели, а у забаненных аккаунтов отдают 403 — поэтому битую картинку
 * подменяем той же иконкой-заглушкой, что и при отсутствии ссылки.
 */
export function MediaThumb({ url, mediaType, className, iconClassName }: MediaThumbProps) {
  const [failed, setFailed] = useState(false);
  const isVideo = mediaType === 'VIDEO' || mediaType === 'REELS';
  const Icon = isVideo ? Video : ImageIcon;

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-muted',
        className,
      )}
    >
      {url && !failed ? (
        <img
          src={url}
          alt=""
          loading="lazy"
          className="size-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <Icon className={cn('text-muted-foreground', iconClassName ?? 'size-4')} />
      )}
    </div>
  );
}
